import initFcAds from 'fc-ads/fc-ads';

// Force webpacker to rebuild: using fc_ads-1.7.9

initFcAds();
